export default __webpack_public_path__ + "static/media/PH-B757.86c75d5a.webp";